import { Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const METRICS = [
  { value: "+%42", label: "nakit akışı verimliliği", testid: "metric-card-efficiency" },
  { value: "%99,9", label: "banka entegrasyon doğruluğu", testid: "metric-card-accuracy" },
  { value: "5 dk", label: "aylık raporlama süresi", testid: "metric-card-time" },
  { value: "2.400+", label: "erken erişim kaydı", testid: "metric-card-signups" },
];

const TESTIMONIALS = [
  {
    quote:
      "Üç farklı banka hesabını Excel'de takip etmeye çalışıyorduk. Akış'a geçtikten sonra ilk ay vadesi kaçan tek bir ödememiz olmadı.",
    name: "Selin Aydın",
    role: "Mali İşler Müdürü, Nova Yapı A.Ş.",
    image:
      "https://images.unsplash.com/photo-1789757348292-f27ee643bd70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxkYXJrJTIwZXhlY3V0aXZlJTIwZmluYW5jaWFsJTIwd29ya3NwYWNlJTIwdGVjaHxlbnwwfHx8fDE3OTA4NTQzMjl8MA&ixlib=rb-4.1.0&q=85",
    testid: "testimonial-card-1",
  },
  {
    quote:
      "Cari hesap bakiyelerini ve yaklaşan tahsilatları tek ekranda görmek, nakit planlamamızı tamamen değiştirdi. Artık tahmin değil, veriyle konuşuyoruz.",
    name: "Emre Kaya",
    role: "Kurucu Ortak, Ege Gıda Ltd.",
    image:
      "https://images.unsplash.com/photo-1774528205285-53a125a51983?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxkYXJrJTIwZXhlY3V0aXZlJTIwZmluYW5jaWFsJTIwd29ya3NwYWNlJTIwdGVjaHxlbnwwfHx8fDE3OTA4NTQzMjl8MA&ixlib=rb-4.1.0&q=85",
    testid: "testimonial-card-2",
  },
];

const Testimonials = () => (
  <section data-testid="testimonials-section" className="relative py-24 sm:py-32">
    <div className="pointer-events-none absolute right-0 top-1/4 h-[360px] w-[360px] rounded-full bg-emerald-500/8 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <div className="grid grid-cols-2 gap-5 lg:grid-cols-4">
        {METRICS.map((m, i) => (
          <Reveal key={m.testid} delay={i * 0.08}>
            <div
              data-testid={m.testid}
              className="rounded-2xl border border-white/8 bg-[#0D111A] px-6 py-7 text-center transition-all duration-500 hover:-translate-y-1 hover:border-emerald-400/40"
            >
              <div className="font-display text-gradient-emerald text-3xl font-extrabold sm:text-4xl">
                {m.value}
              </div>
              <div className="mt-2 text-xs uppercase tracking-[0.14em] text-slate-500 sm:text-sm">
                {m.label}
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-16 grid gap-6 lg:grid-cols-2">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.testid} delay={0.1 + i * 0.12}>
            <figure
              data-testid={t.testid}
              className="group relative h-full overflow-hidden rounded-2xl border border-white/8 bg-[#0D111A] p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-emerald-400/40"
            >
              <Quote className="h-8 w-8 text-emerald-500/40" />
              <blockquote className="mt-5 text-base leading-relaxed text-slate-300 sm:text-lg">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-4">
                <img
                  src={t.image}
                  alt={t.name}
                  className="h-12 w-12 rounded-full border border-emerald-400/30 object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-semibold text-slate-100">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
